import { either, equals, pipe, prop, toLowerCase } from '@/utils/common';
import { isClientSide } from '@/utils/next';
import { notAlphanumeric } from '@/utils/regExp';

export const getTOCLabel = (anchor: string) => {
  if (!isClientSide()) return '';
  const elWrapper = document.getElementById(anchor);
  if (!elWrapper) return '';

  const h2OrH3OnlyTagNames = pipe(prop('tagName'), toLowerCase, either(equals('h2'), equals('h3')));

  const h2Tag = Array.from(elWrapper.children).find(h2OrH3OnlyTagNames);

  if (!h2Tag?.textContent) return '';

  return h2Tag.textContent.replace(notAlphanumeric, '') || '';
};
